import React, {useState, Fragment, useEffect} from "react";

import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";
import useModalAddTeam from "root/Modals/AddTeam/useModalAddTeam";
import "./TeamInfoForm.scss";
import {getTeamDetails} from "root/DataFunctions/TeamDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useSetRecoilState} from "recoil";
import {teamNameAtom} from "root/recoil/teamName";

const TeamInfoForm = (props) => {
  const [data, setData] = useState({ isLoading: true, data: [] });
  const setTeamName = useSetRecoilState(teamNameAtom);

  useEffect(() => {
      getData();
  }, [props.team_id]);

  const getData = () =>{
        getTeamDetails(props.team_id, (response) =>
        {
            let teamData = getDataFromResponse(response)[0] ;
            setData({ isLoading: false, data: teamData});

            // Set the recoil teamNameAtom to the first child
            setTeamName({ name: teamData.team_name, filter: 'Details' });
        });
    }

  const onSaveUpdateTeamCompleted = ( key ) =>
  {
    console.log ( "onSaveComplete" + key ) ;
    getData();
  }

  const [ renderAddTeamDetailsModal, onActivateAddTeamDetailsModal ] = useModalAddTeam(onSaveUpdateTeamCompleted);

 const letterbox_team = +data.data.letterbox_team === 0 ? 'No' : 'Yes';

 return (
    <Fragment>
      <div className="info-page-layout">
          <div className="dt-card dt-card__full-height">
            <div className="dt-card__body">
              <div className="media mb-7">

                  <div className="media-body align-self-center">
                    <h2 className="mb-1">{data.data.team_name}</h2>
                  </div>
              </div>
              <div className="card-text mb-8">
                  <div className="team-info">
                      <p>Name</p>
                      <div>{data.data.team_name}</div>
                      <p>Description</p>
                      <div>{data.data.team_desc}</div>
                  </div>

                  <div className="team-info">
                      <p>Letterbox Team </p>
                      <div>{letterbox_team}</div>
                  </div>
              </div>

              <ActionButton icon='icon-edit' onClick={() => onActivateAddTeamDetailsModal('edit', null, props.team_id)} title="Update"/>
              {renderAddTeamDetailsModal(props)}

                {/* Need to understand who can delete Teams?
                <ActionButton icon='icon-trash' onClick={() => onActivateAddTeamDetailsModal('delete')} title="Delete"/>
              {renderAddTeamDetailsModal(props)}*/}

            </div>
          </div>
      </div>

    </Fragment>
  );
};

export default TeamInfoForm;
